import { css } from 'styled-components';

export const typography = {
  heading: {
    '4xl': css`
      font: var(--typography-heading-4xl);
    `,
    '3xl': css`
      font: var(--typography-heading-3xl);
    `,
    '2xl': css`
      font: var(--typography-heading-2xl);
    `,
    xl: css`
      font: var(--typography-heading-xl);
    `,
    lg: css`
      font: var(--typography-heading-lg);
    `,
    md: css`
      font: var(--typography-heading-md);
    `,
    sm: css`
      font: var(--typography-heading-sm);
    `,
    xs: css`
      font: var(--typography-heading-xs);
    `,
    eyebrow: css`
      font: var(--typography-heading-eyebrow);
      letter-spacing: 2px;
      text-transform: uppercase;
    `,
  },
  body: {
    lg: css`
      font: var(--typography-body-lg);
    `,
    md: css`
      font: var(--typography-body-md);
    `,
    sm: css`
      font: var(--typography-body-sm);
    `,
    xs: css`
      font: var(--typography-body-xs);
    `,
    eyebrow: css`
      font: var(--typography-body-eyebrow);
      letter-spacing: 2px;
      text-transform: uppercase;
    `,
  },
  labels: {
    input: css`
      font: var(--typography-label-input);
    `,
    checkboxRadio: css`
      font: var(--typography-label-checkbox-radio);
    `,
    buttonsLg: css`
      font: var(--typography-label-buttons-lg);
      letter-spacing: 2px;
      text-transform: uppercase;
    `,
    buttonsMd: css`
      font: var(--typography-label-buttons-md);
      letter-spacing: 2px;
      text-transform: uppercase;
    `,
    buttonsSm: css`
      font: var(--typography-label-buttons-sm);
      letter-spacing: 2px;
      text-transform: uppercase;
    `,
  },
};

export const typographyVariables = css`
  :root {
    --typography-font-family-headings: Heebo, sans-serif;
    --typography-font-family-body: Heebo, sans-serif;
    --typography-font-family-labels: Heebo, sans-serif;
    --typography-font-weight-bold: 700;
    --typography-font-weight-regular: 400;
    --typography-size-heading-4xl: 32px;
    --typography-size-heading-3xl: 28px;
    --typography-size-heading-2xl: 24px;
    --typography-size-heading-xl: 20px;
    --typography-size-heading-lg: 18px;
    --typography-size-heading-md: 16px;
    --typography-size-heading-sm: 14px;
    --typography-size-heading-xs: 14px;
    --typography-size-body-lg: 16px;
    --typography-size-body-md: 16px;
    --typography-size-body-sm: 14px;
    --typography-size-body-xs: 12px;
    --typography-size-label-input: 14px;
    --typography-size-label-checkbox-radio: 14px;
    --typography-size-label-button-lg: 12px;
    --typography-size-label-button-md: 12px;
    --typography-size-label-button-sm: 12px;

    --typography-heading-4xl: var(--typography-font-weight-bold)
      var(--typography-size-heading-4xl) / 125%
      var(--typography-font-family-headings);
    --typography-heading-3xl: var(--typography-font-weight-bold)
      var(--typography-size-heading-3xl) / 125%
      var(--typography-font-family-headings);
    --typography-heading-2xl: var(--typography-font-weight-bold)
      var(--typography-size-heading-2xl) / 125%
      var(--typography-font-family-headings);
    --typography-heading-xl: var(--typography-font-weight-bold)
      var(--typography-size-heading-xl) / 125%
      var(--typography-font-family-headings);
    --typography-heading-lg: var(--typography-font-weight-bold)
      var(--typography-size-heading-lg) / 125%
      var(--typography-font-family-headings);
    --typography-heading-md: var(--typography-font-weight-bold)
      var(--typography-size-heading-md) / 125%
      var(--typography-font-family-headings);
    --typography-heading-sm: var(--typography-font-weight-bold)
      var(--typography-size-heading-sm) / 125%
      var(--typography-font-family-headings);
    --typography-heading-xs: var(--typography-font-weight-bold)
      var(--typography-size-heading-xs) / 125%
      var(--typography-font-family-headings);
    --typography-heading-eyebrow: var(--typography-font-weight-bold)
      12px / 150%
      var(--typography-font-family-headings);

    --typography-body-lg: var(--typography-font-weight-regular)
      var(--typography-size-body-lg) / 150%
      var(--typography-font-family-body);
    --typography-body-md: var(--typography-font-weight-regular)
      var(--typography-size-body-md) / 150%
      var(--typography-font-family-body);
    --typography-body-sm: var(--typography-font-weight-regular)
      var(--typography-size-body-sm) / 150%
      var(--typography-font-family-body);
    --typography-body-xs: var(--typography-font-weight-regular)
      var(--typography-size-body-xs) / 150%
      var(--typography-font-family-body);
    --typography-body-eyebrow: var(--typography-font-weight-bold)
      12px / 150%
      var(--typography-font-family-headings);

    --typography-label-input: var(--typography-font-weight-regular)
      var(--typography-size-label-input) / 150%
      var(--typography-font-family-labels);
    --typography-label-checkbox-radio: var(--typography-font-weight-regular)
      var(--typography-size-label-checkbox-radio) / 150%
      var(--typography-font-family-labels);
    --typography-label-buttons-lg: var(--typography-font-weight-bold)
      var(--typography-size-label-button-lg) / 24px
      var(--typography-font-family-labels);
    --typography-label-buttons-md: var(--typography-font-weight-bold)
      var(--typography-size-label-button-md) / 24px
      var(--typography-font-family-labels);
    --typography-label-buttons-sm: var(--typography-font-weight-bold)
      var(--typography-size-label-button-sm) / 24px
      var(--typography-font-family-labels);
  }

  @media (min-width: 768px) {
    :root {
      --typography-size-heading-4xl: 36px;
      --typography-size-heading-3xl: 32px;
      --typography-size-heading-2xl: 26px;
      --typography-size-heading-xl: 22px;
      --typography-size-heading-lg: 20px;
      --typography-size-heading-md: 18px;
      --typography-size-heading-sm: 16px;
      --typography-size-heading-xs: 14px;
      --typography-size-body-lg: 16px;
      --typography-size-body-md: 16px;
      --typography-size-body-sm: 14px;
      --typography-size-body-xs: 12px;
      --typography-size-label-field-group: 16px;
      --typography-size-label-input: 16px;
      --typography-size-label-checkbox-radio: 14px;
      --typography-size-label-button-lg: 12px;
      --typography-size-label-button-md: 12px;
      --typography-size-label-button-sm: 12px;
    }
  }

  @media (min-width: 1024px) {
    :root {
      --typography-size-heading-4xl: 44px;
      --typography-size-heading-3xl: 36px;
      --typography-size-heading-2xl: 28px;
      --typography-size-heading-xl: 24px;
      --typography-size-heading-lg: 22px;
      --typography-size-heading-md: 18px;
      --typography-size-heading-sm: 16px;
      --typography-size-heading-xs: 14px;
      --typography-size-body-lg: 20px;
      --typography-size-body-md: 16px;
      --typography-size-body-sm: 14px;
      --typography-size-body-xs: 12px;
      --typography-size-label-field-group: 16px;
      --typography-size-label-input: 16px;
      --typography-size-label-checkbox-radio: 14px;
      --typography-size-label-button-lg: 14px;
      --typography-size-label-button-md: 14px;
      --typography-size-label-button-sm: 12px;
    }
  }

  @media (min-width: 1440px) {
    :root {
      --typography-size-heading-4xl: 44px;
      --typography-size-heading-3xl: 36px;
      --typography-size-heading-2xl: 28px;
      --typography-size-heading-xl: 24px;
      --typography-size-heading-lg: 22px;
      --typography-size-heading-md: 18px;
      --typography-size-heading-sm: 16px;
      --typography-size-heading-xs: 14px;
      --typography-size-body-lg: 20px;
      --typography-size-body-md: 16px;
      --typography-size-body-sm: 14px;
      --typography-size-body-xs: 12px;
      --typography-size-label-field-group: 16px;
      --typography-size-label-input: 16px;
      --typography-size-label-checkbox-radio: 14px;
      --typography-size-label-button-lg: 14px;
      --typography-size-label-button-md: 12px;
      --typography-size-label-button-sm: 12px;
    }
  }
`;
